import { Award, BadgeCheck, Users } from "lucide-react";

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: Award,
      title: "Esperienza e Competenza",
      description:
        "Oltre 35 anni nel settore: conosciamo ogni prodotto e sappiamo consigliarti al meglio per le tue esigenze specifiche.",
    },
    {
      icon: BadgeCheck,
      title: "Qualità Garantita",
      description:
        "Lavoriamo solo con i migliori marchi e produttori. Ogni articolo è selezionato per garantire risultati eccellenti.",
    },
    {
      icon: Users,
      title: "Servizio Personalizzato",
      description:
        "Ti conosciamo, conosciamo le tue esigenze. Non sei un numero, ma un cliente che seguiamo nel tempo.",
    },
  ];

  return (
    <section className="py-12 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="mb-4 text-primary uppercase text-xl md:text-4xl text-center" style={{ fontFamily: 'Verdana, sans-serif' }}>Perché scegliere Mangimi Rubini</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Qualità, esperienza e passione al servizio dei nostri clienti
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="text-center animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-primary/10 mb-6">
                <benefit.icon className="w-10 h-10 text-primary" />
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground mb-3 uppercase" style={{ fontFamily: 'Verdana, sans-serif' }}>
                {benefit.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed" style={{ fontFamily: 'Verdana, sans-serif' }}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
